export const BASE_PRODUCT_KEYS = {
  S3B_KIOSK: 's3b-kiosk',
};
